enum Mode {
    CONNECT = 0,
    MAIN = 1,
}

export default Mode;